import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

import Manufacturers from './Manufactures';
import { Manufacturer } from '../../../../../interfaces/manufacturer';
import { useManufacturerSearch } from '../../hooks/useManufacturesSearch';
import { PriceFields } from './Price';
import { usePricesFilter } from '../../hooks/usePricesFilter';

export const Filters = ({
  categoryId,
  searchCatalog,
}: {
  categoryId?: number;
  searchCatalog?: string;
}) => {
  const { priceFrom: priceFromSearch, priceTo: priceToSearch, setPrices } = usePricesFilter();
  const [selected, setSelected] = useState<Manufacturer[]>([]);
  const [priceFrom, setPriceFrom] = React.useState<string>(priceFromSearch || '');
  const [priceTo, setPriceTo] = React.useState<string>(priceToSearch || '');
  const { setSearchValues, idsManufacturer } = useManufacturerSearch({
    initCheck: true,
    setSelected,
  });

  useEffect(() => {
    const newSetValues = idsManufacturer.filter(item => !selected.find(el => el.id === item));
    const newSelected = newSetValues.map(item => ({ id: item, name: '' } as Manufacturer));
    setSelected(prev => [...prev, ...newSelected]);
  }, []);

  return (
    <>
      {' '}
      <Box
        display='flex'
        flexDirection='row'
        gap='12px'
        alignItems='center'
        sx={{
          '@media (max-width:768px)': {
            flexWrap: 'wrap',
          },
        }}
      >
        <Box
          sx={{
            order: 1,
            flexShrink: 0,

            width: 44,
            height: 44,

            borderRadius: '999px',
            background: '#fff',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            cursor: 'pointer',
          }}
        >
          <TuneIcon sx={{ fontSize: 22, color: '#181c32' }} />
        </Box>

        <Box
          sx={{
            order: 2,
            '@media (max-width:768px)': {
              order: 3,
              width: '100%',
            },
          }}
        >
          <PriceFields
            priceFrom={priceFrom}
            setPriceFrom={setPriceFrom}
            priceTo={priceTo}
            setPriceTo={setPriceTo}
          />
        </Box>

        <Box
          sx={{
            order: 3,
            '@media (max-width:768px)': {
              order: 4,
              width: '100%',
            },
          }}
        >
          <Manufacturers
            selected={selected}
            setSelected={setSelected}
            categoryId={categoryId}
            searchCatalog={searchCatalog}
          />
        </Box>

        <Box
          sx={{
            order: 4,

            display: 'flex',
            height: '44px',
            width: '234px',
            flexShrink: 0,
            padding: '6px',

            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '22px',
            gap: '6px',

            // borderTop: '1px solid #DDDEE3',

            background: '#fff',

            '@media (max-width:768px)': {
              order: 2,
              marginLeft: 'auto',
            },
          }}
        >
          {/* RESET */}
          <Box
            onClick={() => {
              // setPrices();
              setSearchValues([
                { field: 'mnfc' },
                { field: 'price_from' },
                { field: 'price_to' },
              ]);
              // clear();
              setPriceFrom('');
              setPriceTo('');
              setSelected([]);
            }}
            sx={{
              height: 32,
              flex: 1,

              borderRadius: '999px',

              background: '#dddee1',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              cursor: 'pointer',

              transition: '0.2s',

              '&:hover': {
                background: '#D5D5DA',
              },
            }}
          >
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 500,
                color: '#181c32',
              }}
            >
              Сбросить
            </Typography>
          </Box>

          {/* APPLY */}
          <Box
            onClick={() => {
              // setPrices(priceFrom, priceTo);
              if (selected.length > 0) {
                if (!categoryId) {
                  // const ids = selected.map(item => item.id);
                  // const newIds = idsManufacturer.filter(item => !ids.includes(item));
                  // const mergedArray = [...new Set([...ids, ...newIds])];
                  setSearchValues([
                    { field: 'mnfc', value: String(selected.map(item => item.id).join(',')) },
                    { field: 'price_from', value: priceFrom },
                    { field: 'price_to', value: priceTo },
                  ]);
                  // setMnfc(String(selected.map(item => item.id).join(',')));
                } else {
                  setSearchValues([
                    { field: 'mnfc', value: selected.map(item => String(item.id)).join(',') },
                    { field: 'price_from', value: priceFrom },
                    { field: 'price_to', value: priceTo },
                  ]);
                  // setMnfc(selected.map(item => String(item.id)).join(','));
                }
              } else {
                setSearchValues([
                  { field: 'mnfc' },
                  { field: 'price_from', value: priceFrom },
                  { field: 'price_to', value: priceTo },
                ]);
              }
            }}
            sx={{
              height: '32px',
              flex: 1,

              borderRadius: '999px',

              background: '#ff4200',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              cursor: 'pointer',

              transition: '0.2s',

              '&:hover': {
                background: '#F05400',
              },
            }}
          >
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 600,
                color: '#FFFFFF',
              }}
            >
              Применить
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};
